import { InputLabel, TextField } from '@opendoor/mosaic';
import { useIndxPrefixFilter } from '@opendoor/tessellation';

interface Props {
  disabled?: boolean;
  placeholder?: string;
}

const AddressInput = ({ placeholder = 'Enter in an address' }: Props) => {
  const [filter, setFilterValue] = useIndxPrefixFilter('address.full_address');

  function handleChange(event: any) {
    const { value } = event.target;
    if (value) {
      setFilterValue(value);
    } else {
      setFilterValue('');
    }
  }

  return (
    <div>
      <InputLabel className="mb-4">Search Address</InputLabel>
      <TextField
        placeholder={placeholder}
        value={filter || ''}
        size="small"
        onChange={handleChange}
        variant="outlined"
      />
    </div>
  );
};

export default AddressInput;
